export default __webpack_public_path__ + "static/media/omnicard-logo-h.33e7802d.png";